export const BOOKING_STATUSES = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  IN_PROGRESS: 'inprogress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const STATUS_COLORS = {
  [BOOKING_STATUSES.PENDING]: '#F59E0B',
  [BOOKING_STATUSES.ACCEPTED]: '#10B981',
  [BOOKING_STATUSES.IN_PROGRESS]: '#3B82F6',
  [BOOKING_STATUSES.COMPLETED]: '#6B7280',
  [BOOKING_STATUSES.CANCELLED]: '#EF4444',
};

// Separate pending colors based on who initiated
export const PENDING_COLORS = {
  HOST_INITIATED: '#F59E0B',    // Orange (current)
  WWOOFER_INITIATED: '#8B5CF6', // Purple (new)
};

export const USER_ROLES = {
  HOST: 'host',
  WWOOFER: 'wwoofer',
};

export const VIEW_MODES = {
  LIST: 'list',
  CALENDAR: 'calendar',
};

export const CALENDAR_VIEWS = {
  MONTH: 'dayGridMonth',
  YEAR: 'multiMonthYear',
  MULTI_MONTH_STACK: 'multiMonthStack',
};

export const STATUS_LABELS = {
  [BOOKING_STATUSES.PENDING]: 'Pending',
  [BOOKING_STATUSES.ACCEPTED]: 'Accepted',
  [BOOKING_STATUSES.IN_PROGRESS]: 'In Progress',
  [BOOKING_STATUSES.COMPLETED]: 'Completed',
  [BOOKING_STATUSES.CANCELLED]: 'Cancelled',
};

export const SORT_OPTIONS = {
  DATE_ASC: 'date_asc',
  DATE_DESC: 'date_desc',
  CREATED_ASC: 'created_asc',
  CREATED_DESC: 'created_desc',
};

export const SORT_LABELS = {
  [SORT_OPTIONS.DATE_ASC]: 'Start Date (Oldest First)',
  [SORT_OPTIONS.DATE_DESC]: 'Start Date (Newest First)',
  [SORT_OPTIONS.CREATED_ASC]: 'Created (Oldest First)',
  [SORT_OPTIONS.CREATED_DESC]: 'Created (Newest First)',
};
